const attachmentFilesEquipmentsTypo = {
  label: 'Attachments of this Equipment',
  noResults: 'No results found'
};

export default attachmentFilesEquipmentsTypo;